import _ from 'lodash';

export default {
    computed: {
        kgPrice() {
            // get kg price of subscription type
            const { kgPrice } = this.orderableSubscriptionTypes.find(
                s => s.id === this.subscriptionType,
            );
            return kgPrice;
        },
        peopleAmounts() {
            // count amount of people according to specific total delivery amount
            let appetite = this.appetites[0];
            if (this.appetites.length > 1) {
                appetite = this.appetites[1];
            }
            // buest guess / approximation
            return Number(Math.floor((this.totalAmounts / appetite.factor) / 2).toFixed(0));
        },
        totalAmounts() {
            // sum of total delivery amount
            const { monday, wednesday } = this.amounts;
            const weeklyIntervalId = this.orderableIntervals[0].id;
            const mondayInterval = this.intervals.monday;
            const wednesdayInterval = this.intervals.wednesday;

            // check delivery interval
            const mondayTotal =
                mondayInterval === weeklyIntervalId
                    ? monday
                    : monday * 0.5;
            const wednesdayTotal =
                wednesdayInterval === weeklyIntervalId
                    ? wednesday
                    : wednesday * 0.5;

            if (this.mode === 'private') {
                if (this.privateDeliveryDay === 'monday') {
                    return mondayTotal;
                }
                return wednesdayTotal;
            }
            return mondayTotal + wednesdayTotal;
        },
        earlyDeliverSurcharge() {
            // get early delivery fee based on interval
            const earlyDeliveryFee = this.earlyDeliveryFee;
            const weeklyIntervalId = this.orderableIntervals[0].id;
            const mondayInterval = this.intervals.monday;
            const wednesdayInterval = this.intervals.wednesday;

            const mondaySurcharge =
                mondayInterval === weeklyIntervalId
                    ? earlyDeliveryFee * 4 : earlyDeliveryFee * 2;
            const wednesdaySurcharge =
                wednesdayInterval === weeklyIntervalId
                    ? earlyDeliveryFee * 4 : earlyDeliveryFee * 2;

            if (this.baskets.wednesday.length) {
                return mondaySurcharge + wednesdaySurcharge;
            }
            return mondaySurcharge;
        },
    },
    methods: {
        total(type, isModal) {
            // entire delivery total
            return this.dayTotal('monday', type, isModal) + this.dayTotal('wednesday', type, isModal);
        },
        totalPerPerson(type) {
            const total = this.total(type);
            return (total / this.people);
        },
        // The itemized Preiszusammenstellung modals list one delivery but total
        // it up per week for business (Asana 1218259495473616). Every price in
        // the mixin is monthly for business (weekly interval x4, bi-weekly x2),
        // so /4 is the week either interval averages out to.
        basketsCountPerDelivery(day, basketId) {
            return this.groupedBaskets[day][basketId].length;
        },
        dayTotalPerWeek(day, type) {
            return this.dayTotal(day, type, true) / 4;
        },
        totalPerWeek(type) {
            return this.total(type, true) / 4;
        },
        // Row labels: business drops the delivery multiplier when there is only
        // one basket of a size, private keeps the existing "1 x 6 kg" form.
        basketRowLabel(day, basketId) {
            const weight = `${this.basketWeight(basketId)} kg`;
            if (this.mode !== 'business') {
                return `${this.basketsCount(day, basketId)} x ${weight}`;
            }
            const count = this.basketsCountPerDelivery(day, basketId);
            return count > 1 ? `${count} x ${weight}` : weight;
        },
        extraRowLabel(day, basketId) {
            const { name } = this.groupedBasketsExtra[day][basketId][0];
            if (this.mode !== 'business') {
                return `${this.basketsExtraCount(day, basketId)} x ${name}`;
            }
            const count = this.basketsExtraCount(day, basketId, true);
            return count > 1 ? `${count} x ${name}` : name;
        },
        feeRowLabel(day, name) {
            return this.mode === 'business' ? name : `${this.getIntervalCount(day)} x ${name}`;
        },
        totalPerPersonPerWeek(type) {
            return this.totalPerPerson(type) / 4;
        },
        getIntervalCount(day, id, excludeMode) {
            const weeklyIntervalId = id || this.orderableIntervals[0].id;
            const interval = this.intervals[day];
            if (interval === weeklyIntervalId) {
                return this.mode === 'private' || excludeMode ? 1 : 4;
            }
            return this.mode === 'private' || excludeMode ? 1 : 2;
        },
        getIntervalCountFee(day, id) {
            const weeklyIntervalId = this.orderableIntervals[0].id;
            const interval = id || this.intervals[day];
            if (interval === weeklyIntervalId) {
                return this.mode === 'private' ? 1 : 4;
            }
            return this.mode === 'private' ? 1 : 2;
        },
        interval(day) {
            const interval = this.intervals[day];
            return this.orderableIntervals.find(i => i.id === interval);
        },
        basketWeight(basketId) {
            if (this.orderableBaskets.find(b => b.id === Number(basketId))) {
                return this.orderableBaskets.find(b => b.id === Number(basketId)).kg;
            }
            return 0;
        },
        basketsCount(day, basketId) {
            return this.groupedBaskets[day][basketId].length * this.getIntervalCount(day);
        },
        basketsCountForPrice(day, basketId) {
            return this.groupedBaskets[day][basketId].length * this.getIntervalCountFee(day);
        },
        basketsExtraCount(day, basketId, excludeMode) {
            return this.groupedBasketsExtra[day][basketId].length * this.getIntervalCount(day, this.groupedBasketsExtra[day][basketId][0].interval, excludeMode);
        },
        basketsExtraCountForPrice(day, basketId) {
            return this.groupedBasketsExtra[day][basketId].length * this.getIntervalCountFee(day, this.groupedBasketsExtra[day][basketId][0].interval);
        },
        basketPrice(basketId) {
            const basket = this.allBaskets.find(b => b.id === Number(basketId));
            return basket.price;
        },
        basketsSumPrice(day, basketIndex, basketId) {
            // sum of baskets (i.e. 5x 2kg baskets)
            return this.basketPrice(basketId) * this.basketsCountForPrice(day, basketId);
        },
        basketSumPrice(day, basketIndex, basketId) {
            // sum of baskets (i.e. 5x 2kg baskets)
            return this.basketPrice(basketId) * this.basketsCount(day, basketId);
        },
        extraBasketPrice(day, basketId, isModal) {
            const basket = this.groupedBasketsExtra[day][basketId][0];
            if (isModal) {
                return basket.price * this.basketsExtraCount(day, basketId);
            }
            return basket.price * this.basketsExtraCountForPrice(day, basketId);
        },
        dayTotal(day, type, isModal) {
            // subtotal of day
            let basketsTotal = 0;
            let deliveryFeeTotal = 0;
            let earlyDeliveryFeeTotal = 0;

            if (type === 'subscription' || type === 'all') {
                if (this.groupedBaskets) {
                    if (isModal) {
                        basketsTotal = _.reduce(
                            Object.keys(this.groupedBaskets[day]),
                            (sum, basketId, basketIndex) =>
                                sum + this.basketSumPrice(day, basketIndex, basketId),
                            0,
                        );
                    } else {
                        basketsTotal = _.reduce(
                            Object.keys(this.groupedBaskets[day]),
                            (sum, basketId, basketIndex) =>
                                sum + this.basketsSumPrice(day, basketIndex, basketId),
                            0,
                        );
                    }
                    deliveryFeeTotal = this.getFeeTotal(day, this.deliveryFee, isModal);
                    earlyDeliveryFeeTotal = this.earlyInvoice ? this.getFeeTotal(day, this.earlyDeliveryFee, isModal) : 0;
                }
            }

            let extraBasketsTotal = 0;
            if (type === 'extras' || type === 'all') {
                if (Object.keys(this.groupedBasketsExtra[day]).length) {
                    extraBasketsTotal = _.reduce(
                        Object.keys(this.groupedBasketsExtra[day]),
                        (sum, basketId) =>
                            sum + this.extraBasketPrice(day, basketId, isModal),
                        0,
                    );
                }
            }

            return _.sum([
                basketsTotal,
                extraBasketsTotal,
                deliveryFeeTotal,
                earlyDeliveryFeeTotal,
            ]);
        },
        getFeeTotal(day, fee, isFull) {
            if (this.baskets[day].length || (this.basketExtra && this.basketExtra[day].length)) {
                if (isFull) {
                    return fee * this.getIntervalCount(day);
                }
                return fee * this.getIntervalCountFee(day);
            }
            return 0;
        },
    },
};



// WEBPACK FOOTER //
// ./static/js/Order/mixins/priceMixin.js